module.exports = __webpack_public_path__ + "static/media/ic_pan_card.5faf39ab.svg";